$('form[data-entity-review]').parsley({
    excluded: 'input[type=button], input[type=submit], input[type=reset]',
    inputs: 'input, textarea, select, input[type=hidden], :hidden',
});

$('#writeReview').on('hidden.bs.modal', function () {
    const $form = $('#entity-review');
    $form[0].reset();
});
